import React, { useState } from "react";
import { Alert } from "react-bootstrap";
import { IntroImg, WhiteBoxWrapper, LogoCenter } from "./Login.style";
import { fetchAPI } from "../utils/fetchAPI";

type LoginProps = {
  onLogin: (isLoggedIn: boolean) => void;
};

const Login = ({ onLogin }: LoginProps) => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    setErrorMessage(""); // Resetowanie błędów
    setIsLoading(true); // Ustawienie stanu ładowania

    try {
      const data = await fetchAPI("POST", "login.php", { username, password });

      setIsLoading(false); // Koniec ładowania

      if (data && data.success) {
        onLogin(true);
        window.location.href = "./dashboard";
      } else {
        setErrorMessage(data?.message || "Nieudane logowanie. Spróbuj ponownie.");
      }
    } catch (error) {
      console.error("Błąd logowania:", error);
      setErrorMessage("Wystąpił błąd połączenia. Spróbuj ponownie.");
      setIsLoading(false);
    }
  };

  return (
    <div>
      <WhiteBoxWrapper>
        <div className="container">
          <div className="text-center">
            <LogoCenter />
            <IntroImg className="mt-4 mb-4" />
          </div>
          <h2 className="text-center">
            <b>Zaloguj się</b>
          </h2>
          <form onSubmit={handleLogin} className="mx-auto">
            <div className="mb-3">
              <label htmlFor="username" className="form-label">
                Login:
              </label>
              <input
                type="text"
                id="username"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                required
                className="form-control"
              />
            </div>
            <div className="mb-3">
              <label htmlFor="password" className="form-label">
                Hasło:
              </label>
              <input
                type="password"
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                className="form-control"
              />
            </div>
            <div className="mb-3 text-center">
              <button type="submit" className="btn btn-primary w-100" disabled={isLoading}>
                {isLoading ? "Logowanie..." : "Zaloguj się"}
              </button>
            </div>
            {errorMessage && <Alert variant="danger">{errorMessage}</Alert>}
          </form>
        </div>
      </WhiteBoxWrapper>
      <p className="text-center mt-5">
        www.budochem.com.pl
        <p className="text-center">
          <small>{process.env.REACT_APP_VERSION}</small>
        </p>
      </p>
    </div>
  );
};

export default Login;
